











































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Popup extends Vue {
  @Prop({ default: 'info' }) buttonColor!: string;

  @Prop({ default: 'Cancel' }) cancelButtonText!: string;

  @Prop({ default: 'OK' }) okButtonText!: string;

  @Prop({ default: false }) textButton!: boolean;

  @Prop({ default: 'Title' }) title!: string;

  @Prop({
    default: () => (next: Function) => {
      next();
    },
  })
  onConfirm!: Function;

  dialog: boolean = false;

  error: boolean = false;

  submitting: boolean = false;

  async handleSubmit(e: any) {
    e.preventDefault();
    this.submitting = true;
    await this.handleOk();
    this.submitting = false;
  }

  handleCancel() {
    this.dialog = false;
    this.error = false;
  }

  async handleOk() {
    const closePopup = () => {
      this.dialog = false;
    };
    await this.onConfirm(closePopup);
  }
}
